module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messages && _vm.messages.length),
      expression: "messages && messages.length"
    }],
    staticClass: "msger"
  }, [_c('main', {
    staticClass: "msger-chat"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', [_c('div', {
      staticClass: "msg",
      class: _vm.getMessageClass(message)
    }, [_c('div', {
      staticClass: "msg-img"
    }), _vm._v(" "), _c('div', {
      staticClass: "msg-bubble"
    }, [_c('div', {
      staticClass: "msg-info"
    }, [_vm._v("\"msg-info-time\"}>" + _vm._s(_vm.timeFormat(new Date())))])]), _vm._v(" "), _c('div', {
      staticClass: "msg-label optionLabel"
    }, [_vm._v("\n          " + _vm._s(message.optionLabel) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "msg-text recognitionText"
    }, [_vm._v("\n          " + _vm._s(message.recognitionText) + "\n        ")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c790dec8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/DebugDialog.vue
// module id = 495
// module chunks = 42